import { useOutletContext } from "react-router-dom";
import { KnowledgeBase } from "@/components/KnowledgeBase";
import { BillingCard } from "@/components/BillingCard";

export function SourcesPage() {
  const { documents, refresh } = useOutletContext();
  return <KnowledgeBase documents={documents} refresh={refresh} />;
}

export function BillingPage() {
  const { handleLogout } = useOutletContext();
  return (
    <div className="max-w-xl flex flex-col gap-6 fade-up">
      <h1 className="font-heading text-[40px] lg:text-5xl leading-none tracking-[-0.02em]">Plan and billing</h1>
      <BillingCard />
      <button
        data-testid="mobile-logout-button"
        onClick={handleLogout}
        className="lg:hidden self-start text-sm font-medium underline"
      >
        Sign out
      </button>
    </div>
  );
}
